import React from 'react'
import PropTypes from 'prop-types'
import Loader from 'react-loader-spinner'

const GlgInlineLoadingSpinner = ({ show, className, height, width, color }) => {
  if (show) {
    return (
      <div className={`glg-loading-spinner ${className || ''}`}>
        <Loader type="Oval" color={color} height={height} width={width} />
      </div>
    )
  } else {
    return null
  }
}

GlgInlineLoadingSpinner.propTypes = {
  show: PropTypes.bool,
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
}

GlgInlineLoadingSpinner.defaultProps = {
  show: true,
  height: 24,
  width: 24,
  color: '0088CE',
}

export default GlgInlineLoadingSpinner
